export function calculateOptionProfitLoss(
    optionType: DerivativeOptionType,
    strikePrice: number,
    premiumPaid: number,
    currentUnderlyingPrice: number,
    contractSize: number
): ProfitLossResult {
    const costBasis = premiumPaid * contractSize;
    let intrinsicValue = 0;

    if (optionType === 'call') {
        intrinsicValue = Math.max(0, currentUnderlyingPrice - strikePrice);
    } else {
        intrinsicValue = Math.max(0, strikePrice - currentUnderlyingPrice);
    }

    const currentValue = intrinsicValue * contractSize;
    const profitLoss = currentValue - costBasis;
    const profitLossPercentage = costBasis !== 0 ? (profitLoss / costBasis) * 100 : 0;

    return {
        profitLoss,
        profitLossPercentage,
        currentValue,
        costBasis,
    };
}

export function calculateFuturesProfitLoss(
    entryPrice: number,
    currentPrice: number,
    contractSize: number
): ProfitLossResult {
    const costBasis = entryPrice * contractSize;
    const currentValue = currentPrice * contractSize;
    const profitLoss = currentValue - costBasis;
    const profitLossPercentage = costBasis !== 0 ? (profitLoss / costBasis) * 100 : 0;

    return {
        profitLoss,
        profitLossPercentage,
        currentValue,
        costBasis,
    };
}
